<template>
    <div class="app-avatar">
        <span class="app-avatar__text">{{letter}}</span>
    </div>
</template>

<script>
    export default {
        name: "AppAvatar",
        props: {
            text: {
                type: String,
                default: ''
            }
        },
        computed: {
            letter() {
                const {text} = this
                let letter = text ? text[0] : ''
                return letter
            }
        }

    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .app-avatar {
        position: relative;
        width: 32px;
        height: 32px;
        line-height: 32px;
        font-size: $fontSizeCommon;
        font-weight: $fontWeightBolder;
        border-radius: 50%;
        text-align: center;
        color: $primaryColor;
        color: var(--primaryColor);
        background-color: $componentHighLightColor;
        background-color: var(--componentHighLightColor);
        @include transition-colors;
    }
</style>